import React, { useState, useEffect } from 'react';
import {
  Box, Typography, Button, Container, styled
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';
import LoadingOverlay from 'react-loading-overlay-ts';
import DNALoader from '../../../components/Loaders/DnaLoader.js';
import OrderService from '../order.service.js';
import AuthService from '../../Authentication/auth.service.js';
import Alerts from '../../../components/Alerts/alerts.js';
import { useTranslation } from 'react-i18next';
import pickup from '../../../assets/pickup.svg';
import order1 from '../../../assets/order1.svg';
import deliveryIcon from '../../../assets/delivery.svg';
import ArrowRight from '../../../assets/arrow-right.svg';
import EmptyOrders from '../../../assets/EmptyOrder.svg';
import MyOrderDetails from './OrdersDetails.js';
import DashboardService from "../dashboard.service.js";

const PageHeading = styled(Typography)({
  fontSize: '34px',
  color: '#3488A4',
  fontWeight: '500',
  textAlign: 'center'
});

const CustomerOrders = ({ showOrders, setShowOrders, showDetails, setShowDetails, onClose }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [activeClicked, setActiveClicked] = useState(true);
  const [orders, setOrders] = useState([]);
  const [activeOrdersCount, setActiveOrdersCount] = useState(0);
  const [pastOrdersCount, setPastOrdersCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [showOrderDetails, setShowOrderDetails] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);

  useEffect(() => {
    const observerInstance = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && hasMore) {
        setPage(prevPage => prevPage + 1);
      }
    }, { threshold: 1 });

    const lastCard = document.querySelector('.order-card:last-child');
    if (lastCard) {
      observerInstance.observe(lastCard);
    }

    return () => {
      if (lastCard) {
        observerInstance.unobserve(lastCard);
      }
    };
  }, [orders, hasMore]);


  const { t } = useTranslation();
  const navigate = useNavigate();

  const HandlePayment = (row) => {
    //iph todo: 47
    //console.log("row", row);
    var payload = {
      functionName: "GetInvoiceDetails",
      postData: {
        _id: row?.order_id,
      }
    }
    DashboardService.GetInvoiceDetails(payload).then((res) => {
      //iph todo: 47
      //console.log("res?.data?.data GetInvoiceDetails",res.data.data);
      let row = res?.data?.data;
      setLoading(false);
      if (res.data.status) {
        var getData = {
          functionName: "OnlinePayment",
          row: row,
          invoice_id: row?._id ? row?._id : null,
          amount: parseFloat(row?.total_amount).toFixed(2),
          invoice_number: row?.order_number,
          business_id: row?.business_id
        }
        //iph todo: 47
        //console.log("getData", getData);
        setLoading(true);
        DashboardService.OnlinePayment(getData).then((response) => {
          //iph todo: 47
          //console.log(response);
          setLoading(false);
          if (response.status === 200) {
            //iph todo: 47
            //console.log(response);
            window.open(response.data.data, '_blank');
            //iph todo: 47
            //console.log('Response : ', response);
          } else if (response.status === 401) {
            AuthService.logout();
            navigate("/login");
            window.location.reload();
          } else {
            window.open(response.data.data, '_blank');
          }
        },
          (error) => {
            setLoading(false);
            const errContent =
              (error.response && error.response.data) || error.message || error.toString();
            //iph todo: 47
            //console.log("Net:-", errContent);
            if (errContent) {
              Alerts.swalErrorAlert(errContent);
            } else {
              Alerts.swalErrorAlert(t("Server Error, Please try again later."));
            }
          })
      }
    },
      (error) => {
        setLoading(false);
        const errContent =
          (error.res && error.res.data) || error.message || error.toString();
        //iph todo: 47
        //console.log("Net:-", errContent);
        if (errContent) {
          Alerts.swalErrorAlert(errContent);
        } else {
          Alerts.swalErrorAlert(t("Server Error, Please try again later."));
        }
      })
  }
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const fetchOrders = (active_orders, past_orders, page) => {
    const userString = localStorage.getItem('user');
    const user = JSON.parse(userString);
    const user_id = user['_id'];

    setLoading(true);
    OrderService.getAllOrders(active_orders, past_orders, page, user_id)
      .then((response) => {
        setLoading(false);
        if (response.data.message === "Unauthorized") {
          AuthService.logout();
          navigate("/login");
          window.location.reload();
        } else {
          const newOrders = response.data.orderData || [];
          setOrders(prevOrders => page === 0 ? newOrders : [...prevOrders, ...newOrders]);
          setActiveOrdersCount(response.data.activeOrdersCount);
          setPastOrdersCount(response.data.pastOrdersCount);
          setHasMore(newOrders.length > 0);
        }
      })
      .catch((error) => {
        setLoading(false);
        Alerts.swalErrorAlert(error.message || t("Server Error, Please try again later."));
      });
  };

  useEffect(() => {
    setOrders([]);
    setPage(0);
    setHasMore(true);
    fetchOrders(activeClicked, !activeClicked, 0);
  }, [activeClicked]);

  useEffect(() => {
    if (page > 0) {
      fetchOrders(activeClicked, !activeClicked, page);
    }
  }, [page]);

  const handleActiveOrdersClick = () => setActiveClicked(true);
  const handlePastOrdersClick = () => setActiveClicked(false);

  const handleOrderDetails = (order) => {
    setSelectedOrder(order);
    setShowOrderDetails(true);
  };

  const OrderCard = ({ order }) => {
    return (
      <div
        style={{
          border: '1px solid #D0D5DD',
          borderRadius: '5px',
          padding: '16px',
          maxWidth: '70%',
          margin: '20px auto',
          height: '140px',
          backgroundColor: '#FFF',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between'
        }}
        onClick={() => handleOrderDetails(order)}
        className="order-card">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img src={order1} alt="Order" style={{ width: '24px', height: '24px', marginRight: '12px' }} />
            <div>
              <h5 style={{ margin: 0, fontSize: '14px', fontWeight: 'bold' }}>Order: #{order.order_number}</h5>
              <p style={{ margin: 0, fontSize: '12px', color: '#667085' }}>Items: {order.total_cart_item}</p>
            </div>
          </div>
          <div>
            <p style={{ margin: 0, fontSize: '12px', color: '#667085' }}>
              {moment(order.order_date).format('MMM DD, YYYY - HH:mm')}
            </p>
            {order.status === 'pending' ?
              <Button style={{
                color: 'white',
                border: '1px solid #46b8da',
                backgroundColor: '#5bc0de',
                borderRadius: '4px',
                fontWeight: 'bold',
                display: 'inline-block',
              }} onClick={() => { HandlePayment(order) }}>
                {t("Pay Now")}
              </Button>
              :
              <div
                style={{
                  backgroundColor: '#E6F5E7',
                  color: '#2B8A3E',
                  padding: '4px 8px',
                  borderRadius: '4px',
                  fontSize: '12px',
                  fontWeight: 'bold',
                  display: 'inline-block',
                  marginTop: '8px',
                }}
              >
                {order.status}
                {/* {orderInvoiceDetails?.status !== 'paid' && ( */}
                {/* )} */}
              </div>
            }
          </div>

        </div>
        <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
          {order.deliveryMethod === 'delivery' ? (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <img src={deliveryIcon} alt="Delivery" style={{ width: '24px', height: '24px', marginRight: '8px' }} />
              <span style={{ fontSize: '12px', color: '#667085' }}>Delivery</span>
            </div>
          ) : (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <img src={pickup} alt="Self Pickup" style={{ width: '24px', height: '24px', marginRight: '8px' }} />
              <span style={{ fontSize: '12px', color: '#667085' }}>Self Pickup</span>
            </div>
          )}
          <button
            style={{
              backgroundColor: '#C9F2FF',
              color: '#59A2BB',
              border: 'none',
              borderRadius: '25px',
              padding: '4px 8px',
              fontSize: '12px',
              marginLeft: 'auto',
              cursor: 'pointer',
            }}
            onClick={() => handleOrderDetails(order)}
          >
            View Details
            <img src={ArrowRight} alt="-->" style={{ width: '24px', height: '24px', marginRight: '8px' }} />
          </button>
        </div>
      </div >
    );
  };

  return (
    <Container maxWidth="md" sx={{ py: 4 }} >
      {showOrderDetails ? (
        <MyOrderDetails order={selectedOrder} onBack={() => setShowOrderDetails(false)} />
      ) : (
        <>
          <PageHeading>My Orders</PageHeading>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px', marginTop: '10px' }}>
            <button
              style={{
                backgroundColor: activeClicked ? '#3488A4' : '#EDEDED',
                color: activeClicked ? '#fff' : '#000',
                border: 'none',
                padding: '12px 80px',
                borderRadius: '5px 0px 0px 5px',
                cursor: 'pointer',
              }}
              onClick={handleActiveOrdersClick}
            >
              {activeOrdersCount} ACTIVE ORDERS
            </button>
            <button
              style={{
                backgroundColor: !activeClicked ? '#3488A4' : '#EDEDED',
                color: !activeClicked ? '#fff' : '#000',
                border: 'none',
                borderRadius: '0px 5px 5px 0px',
                padding: '12px 80px',
                cursor: 'pointer',
              }}
              onClick={handlePastOrdersClick}
            >
              {pastOrdersCount} PAST ORDERS
            </button>
          </div>

          {loading && (
            <div style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              opacity: 0.7,
              zIndex: 1
            }}>
              <div style={{
                width: '30px',
                height: '30px',
                border: '3px solid #f3f3f3',
                borderTop: '3px solid #3488A4',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite'
              }} />
            </div>
          )}

          {orders.length === 0 && !loading ? (
            <>
              <Typography align="center" sx={{ mt: 4, color: '#667085' }}>
                <img alt='' src={EmptyOrders} style={{ maxWidth: '100%', height: 'auto' }} />
              </Typography>
              <Typography align="center" sx={{ fontFamily: 'Quick-Sand', fontSize: '26px', mt: 4, color: 'black' }}>
                No Orders Found.
              </Typography>
            </>
          ) : (
            orders.map((order, index) => (
              <OrderCard key={index} order={order} />
            ))
          )}
        </>
      )}
    </Container>
  );
};

export default CustomerOrders;
